module.exports = __webpack_public_path__ + "img/icon02.c4a47d0e.jpg";